import React from "react";
import { Placeholder } from "@bloomberg/media-ui-article";
import styles from "./styles.module.css";

export const NewsletterPlaceholder = () => {
  return (
    <section className={styles.newsletter}>
      <div className={styles.container}>
        <Placeholder.Image className={styles.image} />
        <div className={styles.contentContainer}>
          <Placeholder.Line />
          <Placeholder.Line />
          <Placeholder.Line />
        </div>
      </div>
      <div className={styles.contentContainer}>
        <Placeholder.Line />
      </div>
    </section>
  );
};
